import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseButtonMiniActionImplementation from '~/nasa_ui/base/BaseButtonMiniActionImplementation';
let ButtonMiniActionNavbar = class ButtonMiniActionNavbar extends Mixins(BaseButtonMiniActionImplementation) {
    widthAuto;
    get computedIconColor() {
        return this.iconColor || 'currentColor';
    }
};
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], ButtonMiniActionNavbar.prototype, "iconColor", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], ButtonMiniActionNavbar.prototype, "widthAuto", void 0);
ButtonMiniActionNavbar = __decorate([
    Component
], ButtonMiniActionNavbar);
export default ButtonMiniActionNavbar;
